<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="650"
  [nzVisible]="isVisibleEmailsDrawer" [nzTitle]="'Set Default (' + selectedRoleDataEmailDefault.name  + ')'"
  [nzFooter]="footerTpl" (nzOnClose)="cancelEmailsDrawer()">
  <ng-container *nzDrawerContent>
    <ng-container *ngIf="currentSelectedTab != RoleType.Supplier">
      <label class="select-all-check-box-title" nz-checkbox [(ngModel)]="allChecked"
        (ngModelChange)="updateAllChecked()">
        Select all
      </label>
      <ng-container *ngFor="let data of emailDefault let i=index">
        <div class="set-default-box">
          <label nz-checkbox [(ngModel)]="data.isChecked" class="w-100"
            (ngModelChange)="headerCheckUncheckAll(i,data.isChecked)">{{data.header}}</label>
          <ng-container *ngFor="let childData of data.items let ind=index">
            <label nz-checkbox (ngModelChange)="subHeaderCheckUncheck(i,ind,childData.isChecked)" class="w-100"
              [(ngModel)]="childData.isChecked">{{childData.item}}</label>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="currentSelectedTab == RoleType.Supplier">
      <nz-tabset [nzSelectedIndex]="currentSelectEmailDefaultTab" (nzSelectedIndexChange)="onTabChange($event)">
        <nz-tab nzTitle="Supplier">
          <!-- <label class="select-all-check-box-title" nz-checkbox [(ngModel)]="allSupplierChecked"
            (ngModelChange)="updateAllSupplierChecked()">
            Select all
          </label> -->
          <ng-container *ngFor="let data of supplierEmailDefault let i=index">
            <div class="no-mr-top set-default-box">
              <label nz-checkbox [(ngModel)]="data.isChecked" class="w-100"
                (ngModelChange)="supplierHeaderCheckUncheckAll(i,data.isChecked)">{{data.header}}</label>
              <ng-container *ngFor="let childData of data.items let ind=index">
                <label nz-checkbox (ngModelChange)="supplierSubHeaderCheckUncheck(i,ind,childData.isChecked)" class="w-100"
                  [(ngModel)]="childData.isChecked">{{childData.item}}</label>
              </ng-container>
            </div>
          </ng-container>
        </nz-tab>
        <nz-tab nzTitle="Supplier Bank">
          <label class="select-all-check-box-title" nz-checkbox [(ngModel)]="allChecked"
            (ngModelChange)="updateAllChecked()">
            Select all
          </label>
          <ng-container *ngFor="let data of emailDefault let i=index">
            <div class="no-mr-top set-default-box">
              <label nz-checkbox [(ngModel)]="data.isChecked" class="w-100"
                (ngModelChange)="headerCheckUncheckAll(i,data.isChecked)">{{data.header}}</label>
              <ng-container *ngFor="let childData of data.items let ind=index">
                <label nz-checkbox (ngModelChange)="subHeaderCheckUncheck(i,ind,childData.isChecked)" class="w-100"
                  [(ngModel)]="childData.isChecked">{{childData.item}}</label>
              </ng-container>
            </div>
          </ng-container>
        </nz-tab>
      </nz-tabset>
    </ng-container>
  </ng-container>

  <ng-template #footerTpl>
    <!--*ngIf="canEditRole"-->
    <button *ngIf="canEditRole" nz-button nzType="primary" (click)="handleOkEmailsDrawer()" [nzLoading]="isLoadingOne"
      class="medium-btn small-btn width-100 mr-1">Update</button>
    <button nz-button nzType="default" (click)="cancelEmailsDrawer()" class="dlt-btn width-100">Cancel</button>
  </ng-template>
</nz-drawer>